const apiConfig = {
	api: {
		base: `${process.env.REACT_APP_BASE_API}/portal-fornecedor/`,
		arquivo: `${process.env.REACT_APP_BASE_API}/`,
		cep: 'https://viacep.com.br/ws/',
	},
};

export default apiConfig;
